import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=4bb1a58e&scoped=true&"
import script from "./ReportList.vue?vue&type=script&lang=js&"
export * from "./ReportList.vue?vue&type=script&lang=js&"
import style0 from "./ReportList.vue?vue&type=style&index=0&id=4bb1a58e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb1a58e",
  null
  
)

export default component.exports